import { all, put, takeEvery } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { RequestAction } from "store/entities/actions";
import {
  ISendForwardingInstructionsFailurePayload,
  ISendForwardingInstructionsPayload,
  ISendForwardingInstructionsSuccessPayload,
  LICENSE,
  LicenseActions,
} from "store/entities/license";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { InstructionsModalViewActionsNames } from "./actions";

const InstructionsModalRequestSource = "forwarding-instructions-modal";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* sendForwardingInstructions(action: IActionWithPayload<string, ISendForwardingInstructionsPayload>) {
  const { recipientEmail } = action.payload;
  yield put(
    LicenseActions.sendForwardingInstructions({ recipientEmail, requestSource: InstructionsModalRequestSource })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* sendForwardingInstructionsSuccess(
  action: IActionWithPayload<string, ISendForwardingInstructionsSuccessPayload>
) {
  const { requestSource } = action.payload;
  if (requestSource === InstructionsModalRequestSource) {
    yield put(
      ToastsActions.createToast({
        content: getToastContent(ToastContent.FORWARDING_INSTRUCTIONS_SEND_SUCCESS),
        variant: ToastVariant.Success,
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* sendForwardingInstructionsFailure(
  action: IActionWithPayload<string, ISendForwardingInstructionsFailurePayload>
) {
  const payload = { ...action.payload };
  if (payload.requestSource === InstructionsModalRequestSource) {
    yield put(
      ToastsActions.createToast({
        content: getToastContent(ToastContent.FORWARDING_INSTRUCTIONS_SEND_FAILURE),
        variant: ToastVariant.Error,
        error: payload?.errorObject,
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* instructionsModalViewSagas() {
  yield all([
    takeEvery(InstructionsModalViewActionsNames.SEND_FORWARDING_INSTRUCTIONS, sendForwardingInstructions),
    takeEvery(LICENSE.SEND_FORWARDING_INSTRUCTIONS[RequestAction.SUCCESS], sendForwardingInstructionsSuccess),
    takeEvery(LICENSE.SEND_FORWARDING_INSTRUCTIONS[RequestAction.FAILURE], sendForwardingInstructionsFailure),
  ]);
}
